import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './store';
import App from './App.jsx';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { FormProvider } from './components/js/context/FormContext';

const root = createRoot(document.getElementById('root'));
root.render(
  //Removed strict mode as is was causig issue with USBComboBox
  //<React.StrictMode>
    <Provider store={store}>  
    <FormProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<App />} />
        </Routes>
      </BrowserRouter>
    </FormProvider>
    </Provider>
  //</React.StrictMode>
);
